import { Box, Grid, LinearProgress, Paper, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import './style.css'

export default function ImportProgressBanner({ importStatus }) {
  if (!importStatus?.type) {
    return null
  }

  const title = importStatus.isRunning
    ? `Import en cours : ${importStatus.type}`
    : `Import terminé : ${importStatus.type}`

  return (
    <Grid item component={Paper} className="import-progress-banner">
      <Typography variant="subtitle1" gutterBottom>
        <b>{title}</b>
      </Typography>
      <Box display="flex" alignItems="center" className="import-progress-bar-container">
        <Box width="100%" mr={2}>
          <LinearProgress variant="determinate" value={importStatus.progress} />
        </Box>
        <Box minWidth={50}>
          <Typography variant="body2" color="textSecondary">
            {importStatus.progress}%
          </Typography>
        </Box>
      </Box>
      <Typography variant="body2" color="textSecondary">
        Ligne {importStatus.current.toLocaleString('fr-FR')} / {importStatus.total.toLocaleString('fr-FR')}
        {importStatus.errors > 0 && (
          <span className="import-progress-errors">
            {importStatus.errors} erreur
            {importStatus.errors > 1 ? 's' : ''}
          </span>
        )}
      </Typography>
    </Grid>
  )
}

ImportProgressBanner.propTypes = {
  importStatus: PropTypes.shape({
    isRunning: PropTypes.bool,
    type: PropTypes.string,
    current: PropTypes.number,
    total: PropTypes.number,
    progress: PropTypes.number,
    errors: PropTypes.number,
  }),
}
